export enum SuccessPageMode {
  Default = 'Default',
  Redirect = 'Redirect',
  Custom = 'Custom',
  // Partial = 'Partial'
}
